import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import 'hammerjs';
import { Circles } from 'react-loader-spinner';
import axios from '../common/axios';
import { Box,Typography } from '@mui/material';
import ProgressChartWithTitle from './common/schartwithTitle';
import { useRecoilState } from 'recoil';
import { chartDataState } from '../recoil/atom';
import LineChartWithTitle from './common/linechartwithTitle';
import dayjs from 'dayjs';


const PartPRDChart = ({ height, width,criteriaDate }) => {
    const [chartData, setChartData] = useRecoilState(chartDataState);


    const groupData_W = 
    _(chartData.filter(v=>v.monthweek ==="W"))
      .groupBy('date')
      .map((objs, key) => ({
        date:key,
        'EV': (_.sumBy(objs, "actualQTY")/_.sumBy(objs,"EV_MD"))*100,
        "unit":objs[0].unit
      }))
      .value();
  

      const groupData_M = 
      _(chartData.filter(v=>v.monthweek ==="M"))
        .groupBy('date')
        .map((objs, key) => ({
          date:key,
          'EV': (_.sumBy(objs, "actualQTY")/_.sumBy(objs,"EV_MD"))*100,
          "unit":objs[0].unit
        }))
        .value();
    
  
    const transformedDataWithCumulative = {
        weekProgress: (groupData_W.filter(v=>!isNaN(v.EV))),
        monthProgress:  (groupData_M.filter(v=>!isNaN(v.EV))),
        weekTarget:_.sumBy(chartData.filter(v=>v.monthweek ==="W"), "planQTY") / _.sumBy(chartData.filter(v=>v.monthweek ==="W"), "PV_MD"),
        monthTarget:_.sumBy(chartData.filter(v=>v.monthweek ==="M"), "planQTY") / _.sumBy(chartData.filter(v=>v.monthweek ==="M"), "PV_MD"),
       
      };


 

  
    // if (transformedDataWithCumulative.weekProgress.length===0) {
    //   return  <Box
    //   sx={{
    //     display: 'flex',
    //     justifyContent: 'center',
    //     alignItems: 'center',
    //     height: '100%',
    //   }}
    // >
    //   <Typography variant="body2">데이터가 존재하지 않습니다.</Typography>
    // </Box>;
    // }

        return (
            <LineChartWithTitle
                height={height}
                width={width}
                title="생산성 Trend"
                chartData={transformedDataWithCumulative}
                chart_id="partprd"
                // maxYaxis={max*1.1}
            />
        );
  
};


export default PartPRDChart

